 <section id="container" >
      <!--header start-->
     <app-header></app-header>
      <!--header end-->
      <!--sidebar start-->
      
      <!--sidebar end-->
      <!--main content start-->
      <section >
          <section class="wrapper">
              <!-- page start-->
              <div class="row">
                  <div class="col-lg-12">
                      <ul class="breadcrumb">
                          <li><a href="#"><i class="fa fa-home"></i> Home</a></li>
                          <li><a href="#"> Order Details</a></li>
                           <li><a href="#"> {{verify_code}}</a></li>
                      </ul>
                  </div>
                  
              </div>
              <div class="row">
                  <div class="col-sm-12">
                       <!--collapse start-->
                      <div class="panel-group m-bot20" id="accordion">
                          <div class="panel panel-default">
                           
                              <div class="panel-heading">
                                  <h4 class="panel-title">
                                      <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                                          Customer Information <i class="more-less glyphicon glyphicon-plus"></i>
                                      </a>
                                  </h4>
                              </div>
                              <div id="collapseOne" class="panel-collapse collapse in">
                                  <div class="panel-body">
                                  <div class="alert alert-success fade in" *ngIf="is_order_responded && is_order_responded_success">
                                  <button data-dismiss="alert" class="close close-sm" type="button">
                                      <i class="fa fa-times"></i>
                                  </button>
                                Order has been placed and please check your mail!.
                              </div>
                              
                               <div class="alert alert-block alert-danger fade in " *ngIf="is_order_responded && is_order_responded_failed">
                                  <button data-dismiss="alert" class="close close-sm" type="button">
                                      <i class="fa fa-times"></i>
                                  </button>
                                Something Went Wrong. Please Try Again.
                              </div>
                              <form class="form-horizontal"  #ngForm="ngForm" [formGroup]="customerForm">
                                     <div class="col-sm-6">
                                  <div class="form-group">
                                      <label for="name" class="col-sm-3 control-label">Name <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text"  class="form-control" formControlName="name" placeholder="Name">
                                           
                                        <p class="error-block" *ngIf="customerForm.get('name').invalid && (customerForm.get('name').dirty  || ngForm.submitted)"><span *ngIf="customerForm.controls['name'].errors.required">Please Enter  Name</span></p>
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label for="company_name" class="col-sm-3 control-label">Company Name <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text"  class="form-control" formControlName="company_name" placeholder="Company Name">
                                         
                                          <p class="error-block" *ngIf="customerForm.get('company_name').invalid && (customerForm.get('company_name').dirty  || ngForm.submitted)"><span *ngIf="customerForm.controls['company_name'].errors.required">Please Enter Company Name</span></p>
                                      </div>
                                  </div>
                                  <div class="form-group">
                                   <label for="billing_address" class="col-sm-3 control-label">Billing Address</label>
                                      <div class="col-sm-9">
                                        <textarea style="width:100%" class="form-control" formControlName="billing_address"> </textarea>
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label for="billing_city" class="col-sm-3 control-label">Billing City</label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="billing_city" placeholder="Billing City">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="state" class="col-sm-3 control-label">State/ Province</label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="state" placeholder="State/ Province">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="country" class="col-sm-3 control-label">Country</label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="country" placeholder="Country">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="zipcode" class="col-sm-3 control-label">Zipcode</label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="zipcode" placeholder="Zipcode">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="telephone" class="col-sm-3 control-label">Telephone <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="telephone" placeholder="Telephone">
                                        <p class="error-block" *ngIf="customerForm.get('telephone').invalid && (customerForm.get('telephone').dirty  || ngForm.submitted)"><span *ngIf="customerForm.controls['telephone'].errors.required || customerForm.controls['telephone'].errors.minlength">Please Enter A Valid Telephone</span></p>
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="email" class="col-sm-3 control-label">Client Email <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="email" placeholder="Client Email ">
                                         <p class="error-block" *ngIf="customerForm.get('email').invalid && (customerForm.get('email').dirty  || ngForm.submitted)"><span *ngIf="customerForm.controls['email'].errors.required || customerForm.controls['email'].errors.email">Please Enter A Valid Email</span></p>
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="url" class="col-sm-3 control-label">Url <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="url" placeholder="Url">
                                          <p class="error-block" *ngIf="customerForm.get('url').invalid && (customerForm.get('url').dirty || ngForm.submitted)"><span *ngIf="customerForm.controls['url'].errors.required">Please Enter Url</span></p>
                                      </div>
                                  </div>
                                  <div class="form-group">
                                   <label for="note" class="col-sm-3 control-label">Note</label>
                                      <div class="col-sm-9">
                                          
                                         
                                             <label for="payment_mode_ids" class="col-sm-12 control-label">{{orderDetails.orderrow.note}}</label> 
                                                  
                                              
                                        
                                      </div>
                                  </div>
                                  </div>
                                  
                                    <div class="col-sm-6">
                                      
                                    <div class="form-group">
                                      <label for="Date" class="col-sm-3 control-label">Date:</label>
                                      <div class="col-sm-9">
                                           <label for="Date" class="col-sm-3 control-label">{{creation_date}}</label>
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="order_number" class="col-sm-3 control-label">Order Number:</label>
                                      <div class="col-sm-9">
                                           <label for="Date" class="col-sm-3 control-label">{{order_number}}</label>
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="seo_consultant" class="col-sm-3 control-label">Sales Person :</label>
                                      <div class="col-sm-9">
                                           <label for="Date" class="col-sm-3 control-label">{{seo_consultant}}</label>
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="seo_consultant_email" class="col-sm-3 control-label">Sales Person Email:</label>
                                      <div class="col-sm-9">
                                           <label for="Date" class="col-sm-3 control-label">{{seo_consultant_email}}</label>
                                      </div>
                                  </div>
                                  
                                  
                                  </div>
                                   
                              </form>
                                  </div>
                              </div>
                          </div>
                          <div class="panel panel-default">
                              <div class="panel-heading">
                                  <h4 class="panel-title">
                                      <a  class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                                          Service & Fee Summary
                                          <i class="more-less glyphicon glyphicon-plus"></i>
                                      </a>
                                  </h4>
                              </div>
                              <div id="collapseTwo" class="panel-collapse collapse in" >
                                  <div class="panel-body">
                                  
                                    <section id="no-more-tables">
                                     
                                  <table class="table  table-striped table-condensed cf">
                                      <thead class="cf">
                                      <tr>
                                          <th>Description</th>
                                          <th style="width:20%">Quantity</th>
                                          <th style="text-align:center">Price</th>
                                          <th style="text-align:center;width:20%">Time</th>
                                         
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <ng-container >
                                      <tr 
  *ngFor="let item of orderDetails.orderdetails; let i = index;" >
                                      
                                          <td data-title="Code">
                                         {{item.product_name}}
                                          <div class="order_items" [innerHTML]="item.plist"></div>
                                          </td>
                                          <td data-title="Company"> {{item.quantity}}</td>
                                               <td  data-title="Price" style="text-align:center">{{item.product_price}}</td>
                                          <td  data-title="Price">{{item.payment_type}}</td>
                                          
                                         
                                      </tr>
                                      
                                      </ng-container>
                                      <tr>
                                          <td> </td>
                                          <td ></td>
                                         <td  data-title="Total monthly payment" style="text-align:center">Total monthly payment</td>
                                          <td >{{orderDetails.orderrow.total_monthly_payment}}</td>
                                         
                                      </tr>
                                      <tr>
                                          <td> </td>
                                          <td ></td>
                                          <td  data-title="Total One Time payment" style="text-align:center">Total One Time payment</td>
                                          <td >{{orderDetails.orderrow.total_onetime_payment}}</td>
                                         
                                      </tr>
                                        <tr>
                                          <td> </td>
                                          <td ></td>
                                         <td  data-title="Grand Total" style="text-align:center">Grand Total</td>
                                          <td >{{orderDetails.orderrow.grand_total}}</td>
                                         
                                      </tr>
                                      </tbody>
                                  </table>
                                  
                                  
                              </section>
                              
                              
                                 
                                  </div>
                              </div>
                          </div>
                          
                          
                          <div class="panel panel-default">
                              <div class="panel-heading">
                                  <h4 class="panel-title">
                                      <a  class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                                          Payment
                                          <i class="more-less glyphicon glyphicon-plus"></i>
                                      </a>
                                  </h4>
                              </div>
                            <div id="collapseThree" class="panel-collapse collapse in" >
                             <div class="panel-body">    
                             <form  *ngIf="payment_form_init" class="form-horizontal" #ngForm="ngForm" [formGroup]="paymentForm">
                              
                              <div class="col-sm-6 form-horizontal">
                                  <div class="form-group">
                                      <label for="term" class="col-sm-3 control-label">Terms </label>
                                      <div class="col-sm-9">
                                       <label for="term" class="col-sm-12 control-label">{{orderDetails.orderrow.term}} </label>
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label for="payment_mode_ids" class="col-sm-3 control-label">Modes of payment</label>
                                      <div class="col-sm-9">
                                      
                                         <label for="payment_mode_ids" class="col-sm-12 control-label">{{orderDetails.orderrow.payment_mode}}</label>
                                          
                                      </div>
                                      </div>
                                      <ng-container  *ngIf="payment_mode_ids==1">
                                       <div class="form-group">
                                      <label for="cheque_no" class="col-sm-3 control-label">Check No <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="cheque_no" placeholder="Check No">
                                      </div>
                                  </div>
                                      </ng-container>
                                       <ng-container  *ngIf="payment_mode_ids==3">
                                      <div class="form-group">
                                      <label for="wire_transfer_id" class="col-sm-3 control-label">Wire Transfer Id <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="wire_transfer_id" placeholder="Wire Transfer Id">
                                      </div>
                                  </div>
                                      </ng-container>
                                       <ng-container  *ngIf="payment_mode_ids==4">
                                      <div class="form-group">
                                      <label for="paypalId" class="col-sm-3 control-label">Paypal Id <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="paypalId" placeholder="Paypal Id">
                                      </div>
                                  </div>
                                      </ng-container>
                                      
                                       <ng-container  *ngIf="payment_mode_ids==5">
                                      <div class="form-group">
                                      <label for="echeque_no" class="col-sm-3 control-label">E-Check No <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="echeque_no" placeholder="E-Check No">
                                      </div>
                                  </div>
                                      </ng-container>
                                     <ng-container  *ngIf="payment_mode_ids==2">
                                     
                                      <div class="form-group">
                                      <label for="credit_card_type" class="col-sm-3 control-label">Credit Card Type <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="credit_card_type" placeholder="Credit Card Type">
                                      </div>
                                  </div>
                                  
                                  
                                  <div class="form-group">
                                      <label for="card_name" class="col-sm-3 control-label">Name On Card <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="card_name" placeholder="Name On Card">
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label for="credit_card_no" class="col-sm-3 control-label">Credit Card Number <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="credit_card_no" placeholder="Credit Card Number">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="month" class="col-sm-3 control-label">Expiration Date <span class="red">*</span></label>
                                      <div class="col-sm-3">
                                          <input type="text" class="form-control" formControlName="month" placeholder="month">
                                      </div>
                                       <div class="col-sm-3">
                                          <input type="text" class="form-control" formControlName="year" placeholder="year">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="credit_card_security_code" class="col-sm-3 control-label">Credit Card Security Code : <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="credit_card_security_code" placeholder="Credit Card Security Code">

                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="crd_street_address" class="col-sm-3 control-label">Credit Card Street address <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="crd_street_address" placeholder="Credit Card Street address">
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label for="credit_card_zip_code" class="col-sm-3 control-label">Credit Card Zip Code <span class="red">*</span></label>
                                      <div class="col-sm-9">
                                          <input type="text" class="form-control" formControlName="credit_card_zip_code" placeholder="Credit Card Zip Code ">
                                      </div>
                                  </div>
                                  </ng-container>
                                
                                  </div>
  
                                  </form>
                                  </div>
                                  
                                  </div>
                          </div>
                          
                          
                          <div class="panel panel-default">
                              <div class="panel-heading">
                                  <h4 class="panel-title">
                                      <a  class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapsefour">
                                          Signature & Terms
                                          <i class="more-less glyphicon glyphicon-plus"></i>
                                      </a>
                                  </h4>
                              </div>
                              <div id="collapsefour" class="panel-collapse collapse in" >
                                  <div class="panel-body">
                                  
                                    <form    [formGroup]="signForm" (ngSubmit)="signsubmit()">
                              
                              <div class="col-sm-12 form-horizontal">
                                  <div class="form-group">
                                     
                                      <div class="col-sm-12">
                                     {{orderDetails.sign_text}}
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label  class="col-sm-1 col-xs-1 control-label"><input type="checkbox"  class="form-control" formControlName="el_seg" ></label>
                                      <div class="col-sm-11 col-xs-10 ck_right">
                                      
                                         <label  class="col-sm-12 control-label">  <span class="red">*</span>&nbsp;<a href="http://en.wikipedia.org/wiki/Electronic_signature " onclick="javascript:void window.open('http://en.wikipedia.org/wiki/Electronic_signature ','1351939430174','width=700,height=500,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=1,left=0,top=0');return false;">I agree to use an electronic signature on this electronic comment</a></label>
                                          
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label  class="col-sm-1 col-xs-1 control-label"><input type="checkbox"  class="form-control" formControlName="service_agg" ></label>
                                      <div class="col-sm-11 col-xs-10 ck_right">
                                      
                                         <label  class="col-sm-12 control-label">  <span class="red">*</span>&nbsp;<a href="agreement" onclick="javascript:void window.open('agreement','1351939430174','width=700,height=500,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=1,left=0,top=0');return false;">I agree to service agreement</a></label>
                                          
                                      </div>
                                  </div>
                                  <div class="form-group">
                                      <label  class="col-sm-1 control-label">Signature <span class="red">*</span></label>
                                      <div class="col-sm-4">
                                      
                                         <label  class="col-sm-12 control-label"> <input type="text"  class="form-control" formControlName="signature" ></label>
                                          
                                      </div>
                                  </div>
                                   <div class="form-group">
                                      <label  class="col-sm-1 control-label">Title  <span class="red">*</span></label>
                                      <div class="col-sm-4">
                                      
                                         <label  class="col-sm-12 control-label"> <input type="text"  class="form-control" formControlName="title" ></label>
                                          
                                      </div>
                                  </div>
                                  
                                  <div class="form-group">
                                      <label  class="col-sm-1 control-label">Date and time</label>
                                      <div class="col-sm-4">
                                      
                                         <label  class="col-sm-12 control-label">{{orderDetails.orderrow.confirmed_date}} </label>
                                          
                                      </div>
                                  </div>
                                  
                                   <div class="form-group">
                                      <label  class="col-sm-1 control-label">IP Address</label>
                                      <div class="col-sm-4">
                                      
                                         <label  class="col-sm-12 control-label"> {{orderDetails.orderrow.ip}}</label>
                                          
                                      </div>
                                  </div>
                                  </div>
                                  <div class="col-sm-12">
                                  <div class="form-group">
                                      <div class="col-lg-10">
                                          <button type="submit" class="btn btn-primary"  >Submit</button>
                                           <p class="error-block" *ngIf="is_sign_submitted  &&  (!customerForm.valid || !paymentForm.valid || !signForm.valid)"><span>One or more fields contain errors </span></p>
                                      </div>
                                  </div>
                                  
                                  
                                    <div *ngIf="is_order_loading" class="d-flex justify-content-center">
                                      <div class="spinner-border m-5" style="color:#c02429" role="status">
                                        <span class="sr-only">Loading...</span>
                                      </div>
                                    </div>

                                  </div>
                                 </form>
                                  </div>
                              </div>
                          </div>
                          
                      </div>
                      
                      <!--collapse end-->

                  </div>
                  
              </div>
              
              <!-- page end-->
          </section>
      </section>
      <!--main content end-->
      <!-- Right Slidebar start -->
     
      <!-- Right Slidebar end -->
      <!--footer start-->
      <app-footer></app-footer>
      <!--footer end-->
  </section>